module.exports = __webpack_public_path__ + "frontend/images/languages/en@2x.png?b42499856ad5eee423ccc5113f159d3d";